import PropTypes from 'prop-types'

const APIRequestIcon = ({ className }: { className: string }) => (
  <svg width={48} height={48} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className={className}>
    <title>{'Builder/ Operation/ APIRequestIcon'}</title>
    <g transform="translate(2.000000, 1.000000)" fill="#1A56DB" fillRule="nonzero">
      <path d="M15.836,16.7488165 C16.4595776,17.5376124 16.9608607,18.415785 17.323,19.3538165 L30.834,11.6538165 C33.2342054,14.2638485 37.2145708,14.6480988 40.0697264,12.5454006 C42.9248819,10.4427024 43.7389378,6.52756901 41.9585975,3.46103328 C40.1782571,0.394497548 36.3746264,-0.83974303 33.1329522,0.597198607 C29.891278,2.03414024 28.2514395,5.68131533 29.328,9.05981654 L15.836,16.7488165 Z"></path>
      <path d="M36,31.9428165 C34.0315638,31.943837 32.1552287,32.7766741 30.834,34.2358165 L17.323,26.5358165 C16.9608607,27.4738481 16.4595776,28.3520206 15.836,29.1408165 L29.328,36.8338165 C28.4158273,39.7207368 29.463012,42.8668901 31.9233555,44.6312817 C34.3836989,46.3956733 37.699506,46.378362 40.1412927,44.5883772 C42.5830794,42.7983924 43.5973568,39.6414766 42.6550904,36.764238 C41.712824,33.8869995 39.0276008,31.9416325 36,31.9428165 L36,31.9428165 Z"></path>
      <path d="M8,30.9428165 C3.581722,30.9428165 0,27.3610945 0,22.9428165 C0,18.5245385 3.581722,14.9428165 8,14.9428165 C12.418278,14.9428165 16,18.5245385 16,22.9428165 C15.9950401,27.3590385 12.4162219,30.9378567 8,30.9428165 L8,30.9428165 Z M8,16.9428165 C4.6862915,16.9428165 2,19.629108 2,22.9428165 C2,26.256525 4.6862915,28.9428165 8,28.9428165 C11.3137085,28.9428165 14,26.256525 14,22.9428165 C13.9966926,19.630479 11.3123376,16.9461239 8,16.9428165 Z"></path>
    </g>
  </svg>
)

APIRequestIcon.displayName = 'APIRequestIcon'

APIRequestIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

APIRequestIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'App Builder'
}

export default APIRequestIcon
